import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import ErrorModal from "../../components/ErrorModal";
import handleApiError from "../../../utils/handleApiError";
import SuccessModal from "../../components/SuccessModal";
import axios from "../../../axios";
import FaqForm from "./FaqForm";

export default function FaqEditPage() {
    const { id } = useParams();
    const [form, setForm] = useState({
        question: "",
        answer: "",
    });

    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        axios.get("/admin/faqs").then((res) => {
            const found = res.data.find((faq) => faq.id === id);
            if (found) setForm({ question: found.question, answer: found.answer });
            else setError("FAQ tidak ditemukan.");
        });
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        try {
            await axios.put(`/admin/faqs/${id}`, form);
            setSuccess("Data berhasil diubah!");
        } catch (err) {
            setError(handleApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Link to="/admin/faqs" className=" mt-3">Kembali</Link>
            <ErrorModal error={error} onClose={() => setError("")} />
            <SuccessModal
                message={success}
                onClose={() => {
                    setSuccess("");
                    navigate("/admin/faqs");
                }}
            />
            <div className="card mt-4">
                <div className="card-header border-bottom">
                    <h4 className="mb-0">Edit FAQ</h4>
                </div>
                <div className="card-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <FaqForm form={form} setForm={setForm} onSubmit={handleSubmit} />
                </div>
            </div>
        </>

    );
}
